// extracted by mini-css-extract-plugin
module.exports = {"form":"search_form__AirFo"};